// Reusable 4-point sparkle/burst star matching the Shay Cooks brand logo.
// Use sparingly as accent decoration across the site.
export const Sparkle = ({ size = 24, className = "", color = "currentColor" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    className={className}
    aria-hidden="true"
  >
    <path d="M50 0 C 52 38, 62 48, 100 50 C 62 52, 52 62, 50 100 C 48 62, 38 52, 0 50 C 38 48, 48 38, 50 0 Z" />
  </svg>
);

// Group of sparkles in a container — for decorative section accents.
export const SparkleGroup = ({ className = "", color = "#05071A", opacity = 0.6 }) => (
  <div className={`pointer-events-none ${className}`} style={{ opacity }}>
    <Sparkle size={18} color={color} className="absolute top-0 left-4" />
    <Sparkle size={32} color={color} className="absolute top-8 left-16" />
    <Sparkle size={14} color={color} className="absolute top-20 left-2" />
    <Sparkle size={22} color={color} className="absolute top-28 left-20" />
  </div>
);

export default Sparkle;
